/* eslint-disable react/prop-types */
"use client";

import React from "react";
import AppModalShell, {
  AppModalButton,
  AppModalContentItem,
} from "../common/AppModalShell";

const optionCardClassName =
  "rounded-[22px] border border-white/12 bg-white/10 px-4 py-4 text-left shadow-[inset_0_1px_0_rgba(255,255,255,0.06)]";

export default function DirectChatManageModal({
  open,
  onClose,
  onDelete,
  onDeleteAndBlock,
  submitting = false,
  t,
}) {
  return (
    <AppModalShell
      open={open}
      title={t("chats.direct_chat.manage_title")}
      onClose={onClose}
      closeAriaLabel={t("chats.direct_chat.manage_close_aria")}
      zIndexClassName="z-[120]"
      maxWidthClassName="max-w-md"
      titleClassName="text-[18px] sm:text-2xl"
      bodyClassName="px-5 pb-5 pt-1 sm:px-6 sm:pb-6"
    >
      <AppModalContentItem className="text-center text-[13px] font-semibold leading-[18px] text-white/80">
        {t("chats.direct_chat.manage_description")}
      </AppModalContentItem>

      <AppModalContentItem className={`mt-4 ${optionCardClassName}`}>
        <div className="text-[16px] font-semibold leading-6 text-white">
          {t("chats.direct_chat.manage_delete")}
        </div>
        <p className="mt-2 text-[13px] font-medium leading-[19px] text-white/74">
          {t("chats.direct_chat.manage_delete_body")}
        </p>
        <AppModalButton
          className="mt-4"
          variant="secondary"
          onClick={onDelete}
          disabled={submitting}
          loading={submitting}
        >
          {t("chats.direct_chat.manage_delete_confirm")}
        </AppModalButton>
      </AppModalContentItem>

      <AppModalContentItem className={`mt-3 ${optionCardClassName}`}>
        <div className="text-[16px] font-semibold leading-6 text-white">
          {t("chats.direct_chat.manage_delete_and_block")}
        </div>
        <p className="mt-2 text-[13px] font-medium leading-[19px] text-white/74">
          {t("chats.direct_chat.manage_delete_and_block_body")}
        </p>
        <AppModalButton
          className="mt-4"
          variant="danger"
          onClick={onDeleteAndBlock}
          disabled={submitting}
          loading={submitting}
        >
          {t("chats.direct_chat.manage_delete_and_block_confirm")}
        </AppModalButton>
      </AppModalContentItem>

      <AppModalContentItem className="mt-4">
        <AppModalButton
          variant="secondary"
          onClick={onClose}
          disabled={submitting}
        >
          {t("chats.direct_chat.manage_cancel")}
        </AppModalButton>
      </AppModalContentItem>
    </AppModalShell>
  );
}
